import { render, staticRenderFns } from "./material-properties-detail.vue?vue&type=template&id=1e616075&"
import script from "./material-properties-detail.vue?vue&type=script&lang=js&"
export * from "./material-properties-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports